import { render, staticRenderFns } from "./CreateProjectDetails.vue?vue&type=template&id=576c48f8&scoped=true&"
import script from "./CreateProjectDetails.vue?vue&type=script&lang=js&"
export * from "./CreateProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectDetails.vue?vue&type=style&index=0&id=576c48f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c48f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VProgressCircular,VRow,VSelect,VTextField})
